import { render, staticRenderFns } from "./link-request-modal.vue?vue&type=template&id=55d8888d&scoped=true"
import script from "./link-request-modal.vue?vue&type=script&lang=js"
export * from "./link-request-modal.vue?vue&type=script&lang=js"
import style0 from "./link-request-modal.vue?vue&type=style&index=0&id=55d8888d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d8888d",
  null
  
)

export default component.exports